import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from "@angular/common/http";

import { Observable, BehaviorSubject /*throwError*/ } from 'rxjs';
import { ApiResponse } from '../models/APIResponse';
import { User } from '../models/User';
import { UpdateUserPassword } from '../models/UpdateUserPassword';
import { TwoFactorModel } from '../models/TwoFactorModel';
import { LogModel } from '../models/LogModel';

@Injectable()
export class LoginService {

  private sessionCustomerKey: string = "SET-User-CustomerDetail";

  constructor(private http: HttpClient) {
  }

  login(username: string, password: string): Observable<Number> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    }

    let user: User = { username: username, password: password };

    return this.http.post<any>('/Portal/Login', JSON.stringify(user), httpOptions);
  }

  ssoLogin(sToken: string, deviceId: number): Observable<Number> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    }

    return this.http.get<any>('/Portal/SSOLogin?stoken=' + sToken + '&deviceId=' + deviceId, httpOptions);
  }

  resetPassword(username: string): Observable<ApiResponse> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    }

    const params = new HttpParams()
      .set('username', username);

    return this.http.get<ApiResponse>('/Portal/ResetPassword', { params });
  }

  forgetUsername(email: string): Observable<ApiResponse> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    }

    const params = new HttpParams()
      .set('email', email);

    return this.http.get<ApiResponse>('/Portal/LookupUsername', { params });
  }

  updateResetPassword(username: string, oldPassword: string, password: string): Observable<ApiResponse> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    }

    let user: UpdateUserPassword = { username: username, password: password, oldPassword: oldPassword };

    return this.http.post<ApiResponse>('/Portal/UpdatePassword', JSON.stringify(user), httpOptions);
  }

  sendTwoFactorRequest(orgid: number, method: number, address: string, identifier: string): Observable<ApiResponse> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    }

    let model: TwoFactorModel = { OrgId: orgid, Method: method, Address: address, AuthType: 1, Identifier: identifier };

    return this.http.post<ApiResponse>('/Portal/SendTwoFactorRequest', JSON.stringify(model), httpOptions);
  }

  userLog(userId: string, orgId: number, eType: string, ipAddy: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    }

    let model: LogModel = { UserIdGuid: userId, OrgId: orgId, EventType: eType, IPAddress: ipAddy };
    return this.http.post<any>('/Portal/UserLog', JSON.stringify(model), httpOptions);
  }

  getIpAddress(orgId: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    }

    const params = new HttpParams()
      .set('orgId', orgId);

    return this.http.get<any>('/Portal/GetIPAddress', { params });
  }

  validateTwoFactorRequest(orgId: string, authType: string, meterId: string, code: string): Observable<ApiResponse>  {
    const params = new HttpParams()
      .set('orgId', orgId)
      .set('authType', authType)
      .set('meterId', meterId)
      .set('code', code);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: params
    }

    return this.http.get<ApiResponse>('/Portal/ValidateTwoFactorInfo', httpOptions);
  }

  getUserIsLoggedIn() {
    return Observable.of(this.getIsLoggedIn());
  }

  getIsLoggedIn() {
    return this.getUserContextDetail() != null;
  }

  clearUserContext() {
    localStorage.removeItem(this.sessionCustomerKey);
  }

  setUserContextDetail(details: any) {
    localStorage.setItem(this.sessionCustomerKey, JSON.stringify(details));
  }

  getUserContextDetail() {
    const context = localStorage.getItem(this.sessionCustomerKey);
    if (context) {
      return JSON.parse(context);
    }
    return null;
  }

  getUserContext() {
    var context = this.getUserContextDetail();
    return Observable.of(context);
  }

  getCustomerAccounts() {
    var context = this.getUserContextDetail();
    if (!context) {
      return Observable.of(null);
    }

    return Observable.of(context.accountsWithDevices);
  }

  getCustomerAccountDetails() {
    var context = this.getUserContextDetail();
    if (!context) {
      return Observable.of(null);
    }

    return Observable.of(context.accountDetails);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/login.service.ts